import { IsNotEmpty, IsString } from 'class-validator';

export class Ref {
  @IsString()
  @IsNotEmpty()
  id: string;

  @IsString()
  @IsNotEmpty()
  nome: string;
}
